exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart[data-v-47911a89]{width:100%;box-shadow:0 1px 10px 3px #c4d3e0}.cart .cart-header[data-v-47911a89]{margin:2rem 1rem}.cart .preview[data-v-47911a89]{width:100px;height:100px;margin:1rem 0;text-align:center}@media print{.cart .preview[data-v-47911a89]{height:48px;width:48px;margin:.25rem}}.cart .totals[data-v-47911a89]{font-size:16px;border-bottom:none}.cart .totals p[data-v-47911a89]{display:flex;justify-content:space-between}.cart .totals[colspan][data-v-47911a89]{display:block;width:30%}.cart .totals .total-titles[data-v-47911a89]{font-size:20px;font-weight:600;padding:0 2rem}", ""]);

// exports
